module.exports = __webpack_public_path__ + "static/snippets-ab555448607026433bc66e3966608708.mp4";